import { useTranslation } from '@/i18n';
import { TextLink } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, memo } from 'react';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

export const Error5XX: FC = memo(() => {
  const { t } = useTranslation();

  return (
    <div className={cx(styles['page'])}>
      <div className={cx(styles['container'])}>
        <h2 className={cx(styles['title'])}>{t('system_error_5XX_title')}</h2>
        <p className={cx(styles['body'])}>{t('system_error_5XX_body')}</p>
        <p className={cx(styles['links'])}>
          <ul>
            <li>
              <TextLink
                target='_blank'
                href='https://biz.moneyforward.com/support/guide/contact.html#payable'
              >
                {t('link_text_inquiry_page')}
              </TextLink>
            </li>
          </ul>
        </p>
        <p className={cx(styles['footer'])}>
          <TextLink href='/'>{t('link_text_top_page')}</TextLink>
        </p>
      </div>
    </div>
  );
});

Error5XX.displayName = 'Error5XX';
